import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MatLegacyListOption as MatListOption, MatLegacySelectionList as MatSelectionList } from '@angular/material/legacy-list';
import { Filters } from 'src/app/models/general/filters.model';
import { ParamEntity } from 'src/app/models/general/param.model';
import { Reporte } from 'src/app/models/rrhh/reporte.model';
import { ReporteService } from 'src/app/services/reporte.service';
import { UserValuesService } from 'src/app/services/utils/user-values.service';

@Component({
  selector: 'app-selection-list',
  templateUrl: './selection-list.component.html',
  styleUrls: ['./selection-list.component.scss']
})
export class SelectionListComponent implements OnInit {
  // @ViewChild(MatSelectionList, { static: true })
  // private selectionList: MatSelectionList;
  @Output() selectedOptionEmit = new EventEmitter<Filters>();
  reportesList: Reporte[];
  selectedReporte: Reporte;

  constructor(
    private reporteService: ReporteService,
    private userValuesService: UserValuesService
  ) { }

  ngOnInit() {
    this.getReportesList();
    this.selectedReporte = new Reporte();
  }

  getSelectedOption(event) {
    this.selectedReporte = event.value;
    const reporte: Filters = {
      reporte: this.selectedReporte
    };
    this.selectedOptionEmit.emit(reporte);
  }

  private getReportesList() {
    const paramEntity = new ParamEntity();
    paramEntity.IdEmpresa = this.userValuesService.getUsuarioValues.IdEmpresa;
    paramEntity.IdUsuario = this.userValuesService.getUsuarioValues.IdUsuario;

    this.reporteService.getReportesListService(paramEntity).subscribe((result: Reporte[]) => {
      if (result) {
        this.reportesList = result;
      }
    });
  }

}
